namespace TabAurous.Reports {
    export interface ItemsRegisterRow {
        TransId?: number;
        TransItemId?: number;
        ProductId?: number;
        AttributeId?: number;
        Status?: string;
        Image?: string;
        ImageLength?: number;
        OrderNo?: string;
        ProductCode?: string;
        ProductName?: string;
        StampCode?: string;
        ProductSizeCode?: string;
        SuperTypeCode?: string;
        RefNo?: string;
        Pieces?: number;
        CompanyCode?: string;
        DeptName?: string;
        Party?: string;
        VoucherDate?: string;
        MetalGrossWeight?: number;
        MetalNetWeight?: number;
        DiamondWeight?: number;
        TotalDiamondWeight?: number;
        PreciousStoneWeight?: number;
        SemiPreciousStoneWeight?: number;
        GrossAmount?: number;
        MF?: number;
        MFAmount?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        PartyId?: number;
    }

    export namespace ItemsRegisterRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Reports.ItemsRegister';
        export const deletePermission = 'Reports:Transaction:Items Register';
        export const insertPermission = 'Reports:Transaction:Items Register';
        export const readPermission = 'Reports:Transaction:Items Register';
        export const updatePermission = 'Reports:Transaction:Items Register';

        export declare const enum Fields {
            TransId = "TransId",
            TransItemId = "TransItemId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Status = "Status",
            Image = "Image",
            ImageLength = "ImageLength",
            OrderNo = "OrderNo",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            StampCode = "StampCode",
            ProductSizeCode = "ProductSizeCode",
            SuperTypeCode = "SuperTypeCode",
            RefNo = "RefNo",
            Pieces = "Pieces",
            CompanyCode = "CompanyCode",
            DeptName = "DeptName",
            Party = "Party",
            VoucherDate = "VoucherDate",
            MetalGrossWeight = "MetalGrossWeight",
            MetalNetWeight = "MetalNetWeight",
            DiamondWeight = "DiamondWeight",
            TotalDiamondWeight = "TotalDiamondWeight",
            PreciousStoneWeight = "PreciousStoneWeight",
            SemiPreciousStoneWeight = "SemiPreciousStoneWeight",
            GrossAmount = "GrossAmount",
            MF = "MF",
            MFAmount = "MFAmount",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            PartyId = "PartyId"
        }
    }
}
